import DOMPurifyModule from 'dompurify'

type DomPurifyLike = {
  sanitize: (dirty: string, config?: Record<string, unknown>) => string
}

function getDomPurify(): DomPurifyLike | null {
  const mod = DOMPurifyModule as unknown as {
    sanitize?: DomPurifyLike['sanitize']
    default?: DomPurifyLike
  }

  if (typeof mod?.sanitize === 'function') {
    return mod as unknown as DomPurifyLike
  }

  if (mod?.default && typeof mod.default.sanitize === 'function') {
    return mod.default
  }

  return null
}

export function sanitizeWithDOMPurify(dirty: string, config?: Record<string, unknown>): string {
  const purifier = getDomPurify()
  if (!purifier) return dirty
  return purifier.sanitize(dirty, config)
}
